import Component, { mixins } from 'vue-class-component'
import { Ref } from 'vue-property-decorator'

import WithRender from './FormInscriptionOffreCours.html'

import {
  FormGroup,
  MButton,
  MButtonSkin,
  MButtonType,
  MForm,
  MMessage,
  MMessageSkin,
  MMessageState,
  MModal,
  MSpinner,
  MToast,
  MToastPosition,
  MToastState
} from '@ulaval/modul-components'

import InscriptionOffreCoursPanel from '@/modules/inscription-lieu-examen/form/InscriptionOffreCoursPanel'
import InscriptionLieuExamenForm, { EVENTS as InscriptionLieuExamenForm_EVENTS, IUpdateInscriptionLieuExamen, IUpdateTypeInscriptionLieuExamen } from '@/modules/inscription-lieu-examen/form/InscriptionLieuExamenForm'

import IFormInscriptionOffreCours from './IFormInscriptionOffreCours.model'
import IDossierEtudiant, { StatutInscription } from '../IDossierEtudiant.model'
import IFormInscriptionLieuExamen from './IFormInscriptionLieuExamen.model'
import { ICity } from '@/modules/global/localization/city/ICity.model'

import InscriptionLieuExamenService, { IUpdateInscriptionLieuExamenRequestPayload, EVENTS as InscriptionLieuExamenService_EVENTS } from '../InscriptionLieuExamen.service'
import CountryService from '@/modules/global/localization/country/Country.service'
import CityService from '@/modules/global/localization/city/City.service'

import EventBus from '@/EventBus'

import { STORE_GETTERS } from '@/store'

const REF_INSCRIPTION_OFFRE_COURS_PANEL: string = 'inscription-offre-cours-panel'
const REF_CONFIRMATION_DIALOG: string = 'confirmation-dialog'

@WithRender
@Component({
  components: {
    InscriptionOffreCoursPanel,
    MButton,
    MForm,
    MMessage,
    MModal,
    MSpinner,
    MToast
  }
})
export default class FormInscriptionOffreCours extends mixins(CityService, CountryService, InscriptionLieuExamenService) {
  public formGroup: FormGroup = new FormGroup({})
  private inscriptionsOffreCours: Array<IFormInscriptionOffreCours> = []
  private isFormInscriptionsOffreCoursLoadingStateActive: boolean = false
  private formIdsInError: number[] = []
  private formIdsStateChanged: number[] = []
  private isConfirmationDialogActive: boolean = false
  private isSaveFormInscriptionsOffreCoursLoadingStateActive: boolean = false
  private isSaveFormInscriptionsOffreCoursSuccessStateActive: boolean = false
  private isSaveFormInscriptionsOffreCoursErrorStateActive: boolean = false
  private requestPayloads: { [key: number]: IUpdateInscriptionLieuExamenRequestPayload } = {}

  private readonly MButtonSkin: object = MButtonSkin
  private readonly MButtonType: object = MButtonType
  private readonly MMessageSkin: object = MMessageSkin
  private readonly MMessageState: object = MMessageState
  private readonly MToastPosition: object = MToastPosition
  private readonly MToastState: object = MToastState
  private readonly REF_INSCRIPTION_OFFRE_COURS_PANEL: string = REF_INSCRIPTION_OFFRE_COURS_PANEL
  private readonly REF_CONFIRMATION_DIALOG: string = REF_CONFIRMATION_DIALOG
  private readonly StatutInscription: object = StatutInscription

  @Ref(REF_INSCRIPTION_OFFRE_COURS_PANEL)
  private inscriptionOffreCoursPanelComponents!: Array<InscriptionOffreCoursPanel> | InscriptionOffreCoursPanel | null

  @Ref(REF_CONFIRMATION_DIALOG)
  private confirmationDialogComponent!: MModal

  private get dossierEtudiant(): IDossierEtudiant | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_DOSSIER_ETUDIANT]
  }

  private get citiesById(): { [key: number]: ICity } {
    return this.$store.getters[STORE_GETTERS.CITY_GET_CITIES_BY_ID] || {}
  }

  private get formErrorMessage(): string {
    return this.$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.message.form_errors.content', {
      postProcess: 'interval',
      count: this.formIdsInError.length
    })
  }

  private get formStateChangeMessage(): string {
    return this.$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.message.form_state_changed.content', {
      postProcess: 'interval',
      count: this.formIdsStateChanged.length
    })
  }

  private get isSubmitButtonDisabled(): boolean {
    return this.formIdsInError.length > 0 || this.formIdsStateChanged.length <= 0
  }

  private created(): void {
    this.loadTypesInscriptionLieuExamen()
    this.loadCountries()
    this.loadFormInscriptionsLieuExamen()
    this.loadCities()
  }

  private mounted(): void {
    this.onUpdateTypeInscriptionLieuExamen()
    this.onUpdateInscriptionLieuExamen()
    this.afterInscriptionLieuExamenUpdate()
  }

  private afterInscriptionLieuExamenUpdate(): void {
    EventBus.$on(InscriptionLieuExamenService_EVENTS.AFTER_UPDATE, () => {
      this.formIdsInError = []
      this.formIdsStateChanged = []
    })
  }

  private onUpdateTypeInscriptionLieuExamen(): void {
    EventBus.$on(InscriptionLieuExamenForm_EVENTS.UPDATE_TYPE_INSCRIPTION_LIEU_EXAMEN, (payload: IUpdateTypeInscriptionLieuExamen) => {
      if (payload && payload.identifier) {
        this.removeFormIdInError(payload.identifier)
      }
    })
  }

  private onUpdateInscriptionLieuExamen(): void {
    EventBus.$on(InscriptionLieuExamenForm_EVENTS.UPDATE_INSCRIPTION_LIEU_EXAMEN, (payload: IUpdateInscriptionLieuExamen) => {
      if (payload && payload.identifier) {
        if (payload.stateChanged) {
          if (!this.formIdsStateChanged.includes(payload.identifier)) {
            this.$set(this.formIdsStateChanged, this.formIdsStateChanged.length, payload.identifier)
          } 
        } else {
          const index: number | undefined = this.formIdsStateChanged.findIndex((identifier: number) => identifier === payload.identifier)

          if (~index) {
            this.$delete(this.formIdsStateChanged, index)
          }
        }

        if (payload.component) {
          this.validateInscriptionLieuExamenForm(payload.component)
        }
      }
    })
  }

  private loadTypesInscriptionLieuExamen(): void {
    this.service_inscriptionLieuExamenService_fetchTypesInscriptionsOffreCours()
  }

  private loadCountries(): void {
    this.service_countryService_fetchCountries()
  }

  private loadCities(): void {
    this.service_cityService_fetchCities()
  }

  private loadFormInscriptionsLieuExamen(): void {
    this.isFormInscriptionsOffreCoursLoadingStateActive = true

    this.service_inscriptionLieuExamenService_fetchFormInscriptionsOffreCours(this.$route.params.token)
      .then((response: Array<IFormInscriptionOffreCours>) => {
        this.inscriptionsOffreCours = response || []
      }).finally(() => {
        this.isFormInscriptionsOffreCoursLoadingStateActive = false
      })
  }

  private async onFormSubmit(): Promise<void> {
    this.formGroup.waiting = true
    this.formIdsInError = []

    let components: Array<InscriptionOffreCoursPanel> = []
    const payloads: { [key: number]: IUpdateInscriptionLieuExamenRequestPayload } = {}

    if (this.inscriptionOffreCoursPanelComponents) {
      if (!Array.isArray(this.inscriptionOffreCoursPanelComponents)) {
        components = [this.inscriptionOffreCoursPanelComponents]
      } else {
        components = this.inscriptionOffreCoursPanelComponents
      }
    }

    for (let i: number = 0; i < components.length; i++) {
      const inscriptionOffreCoursPanelComponent: InscriptionOffreCoursPanel = components[i]

      let childComponents: Array<InscriptionLieuExamenForm> = []

      if (inscriptionOffreCoursPanelComponent.inscriptionLieuExamenFormComponents) {
        if (!Array.isArray(inscriptionOffreCoursPanelComponent.inscriptionLieuExamenFormComponents)) {
          childComponents = [inscriptionOffreCoursPanelComponent.inscriptionLieuExamenFormComponents]
        } else {
          childComponents = inscriptionOffreCoursPanelComponent.inscriptionLieuExamenFormComponents
        }
      }
      
      for (let j: number = 0; j < childComponents.length; j++) {
        const inscriptionLieuExamenFormComponent: InscriptionLieuExamenForm = childComponents[j]
        const formData: IUpdateInscriptionLieuExamenRequestPayload | undefined = await this.validateInscriptionLieuExamenForm(inscriptionLieuExamenFormComponent)

        if (formData) {
          payloads[formData.idInscriptionLieuExamen] = formData
        }
      }
    }

    this.formGroup.waiting = false
    this.requestPayloads = payloads

    if (this.formIdsInError.length === 0) {
      this.openConfirmationDialog()
    }
  }

  private async validateInscriptionLieuExamenForm(component: InscriptionLieuExamenForm): Promise<IUpdateInscriptionLieuExamenRequestPayload | undefined> {
    if (!component) {
      return undefined
    }

    await component.formGroup.submit()

    if (await component.formGroup.hasErrorDeep()) {
      if (!this.formIdsInError.includes(component.identifier)) {
        this.$set(this.formIdsInError, this.formIdsInError.length, component.identifier)
      }
    } else {
      this.removeFormIdInError(component.identifier)

      const formData: IUpdateInscriptionLieuExamenRequestPayload | undefined = component.getFormData()

      if (formData) {
        return formData
      }
    }

    return undefined
  }

  private removeFormIdInError(id: number): void {
    const index: number | undefined = this.formIdsInError.findIndex((identifier: number) => identifier === id)

    if (~index) {
      this.$delete(this.formIdsInError, index)
    }
  }

  private updateInscriptionsLieuExamen(): void {
    this.isSaveFormInscriptionsOffreCoursLoadingStateActive = true

    this.service_inscriptionLieuExamenService_saveFormInscriptionsOffreCours(this.$route.params.token, Object.values(this.requestPayloads))
      .then((response: Array<IFormInscriptionOffreCours>) => {
        this.inscriptionsOffreCours = response || []
        this.formIdsStateChanged = []

        this.isSaveFormInscriptionsOffreCoursSuccessStateActive = true
        this.isSaveFormInscriptionsOffreCoursErrorStateActive = false
      }).catch(() => {
        this.isSaveFormInscriptionsOffreCoursSuccessStateActive = false
        this.isSaveFormInscriptionsOffreCoursErrorStateActive = true
      }).finally(() => {
        this.isSaveFormInscriptionsOffreCoursLoadingStateActive = false
      })
  }

  private openConfirmationDialog(): void {
    this.isConfirmationDialogActive = true
    this.isSaveFormInscriptionsOffreCoursErrorStateActive = false
    this.isSaveFormInscriptionsOffreCoursLoadingStateActive = false
    this.isSaveFormInscriptionsOffreCoursSuccessStateActive = false
  }

  private closeConfirmationDialog(): void {
    this.confirmationDialogComponent.closeModal()
  }

  private afterCloseConfirmationDialog(): void {
    this.isConfirmationDialogActive = false
    this.isSaveFormInscriptionsOffreCoursErrorStateActive = false
    this.isSaveFormInscriptionsOffreCoursLoadingStateActive = false
    this.isSaveFormInscriptionsOffreCoursSuccessStateActive = false
  }

  private generateConfirmationSituationLabel(inscriptionLieuExamen: IFormInscriptionLieuExamen): string | undefined {
    const payload: IUpdateInscriptionLieuExamenRequestPayload | null = this.requestPayloads[inscriptionLieuExamen.id] || null

    if (!payload) {
      return undefined
    }

    const city: ICity | undefined = this.citiesById[payload.idVille as number]

    return this.$i18next.t(`modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_lieu_examen.situation.${payload.slugTypeInscriptionLieuExamen}`, {
      ...payload,
      ville: city ? city.nom : ''
    })
  }

  private hasInscriptionOffreCoursChanged(inscriptionOffreCours: IFormInscriptionOffreCours): boolean {
    if (inscriptionOffreCours.inscriptionsLieuExamen) {
      for (const inscriptionLieuExamen of inscriptionOffreCours.inscriptionsLieuExamen) {
        if (this.formIdsStateChanged.includes(inscriptionLieuExamen.id)) {
          return true
        }
      }
    }

    return false
  }
}
